import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { environment as env } from 'src/environments/environment';
import { SharedModule } from './shared/shared.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FilterClientPipe } from './shared/pipes/filterClient.pipe';
import { FilterEntitlementClientNamePipe } from './shared/pipes/filterEntitlement.pipe';
import { FilterServiceNamePipe } from './shared/pipes/filterService.pipe';
import { FilterEntitlementValuePipe } from './shared/pipes/filterEntitlement.pipe';
import {
  MsalBroadcastService,
  MsalGuard,
  MsalGuardConfiguration,
  MsalInterceptor,
  MsalInterceptorConfiguration,
  MsalModule,
  MsalService,
  MSAL_GUARD_CONFIG,
  MSAL_INSTANCE,
  MSAL_INTERCEPTOR_CONFIG,
} from '@azure/msal-angular';
import {
  BrowserCacheLocation,
  InteractionType,
  IPublicClientApplication,
  PublicClientApplication,
} from '@azure/msal-browser';
import { AutocompleteLibModule } from 'angular-ng-autocomplete';
import { EntitlementServiceComponent } from './entitlement/entitlement-service/entitlement-service.component';
import { EntitlementServiceClientComponent } from './entitlement/entitlement-service-client/entitlement-service-client.component';
import { EntitlementClientComponent } from './entitlement/entitlement-client/entitlement-client.component';
import { ServiceComponent } from './service/service.component';
import { HomeComponent } from './home/home.component';
import { ClientInputComponent } from './entitlement/entitlement-service/client-input/client-input.component';
import { ClientComponent } from './client/client.component';
import { ServiceCardComponent } from './service/components/service-card/service-card.component';
import { ApiDocumentComponent } from './api-document/api-document.component';
import { UnityModule } from '@emorg-prd/ngx-unity';
import { SearchKeyInputComponent } from './entitlement/entitlement-service-client/search-key-input/search-key-input.component';

const isIE =
  window.navigator.userAgent.indexOf('MSIE ') > -1 ||
  window.navigator.userAgent.indexOf('Trident/') > -1; // Remove this line to use Angular Universal

export function MSALInstanceFactory(): IPublicClientApplication {
  return new PublicClientApplication({
    auth: {
      clientId: env.client_id,
      authority:
        'https://login.microsoftonline.com/d1ee1acd-bc7a-4bc4-a787-938c49a83906',
      redirectUri: env.app_url,
    },
    cache: {
      cacheLocation: BrowserCacheLocation.LocalStorage,
      storeAuthStateInCookie: isIE, // set to true for IE 11. Remove this line to use Angular Universal
    },
  });
}

export function MSALInterceptorConfigFactory(): MsalInterceptorConfiguration {
  const protectedResourceMap = new Map<string, Array<string>>();
  protectedResourceMap.set('https://graph.microsoft.com/', ['user.read']);
  protectedResourceMap.set(env.base_api_url, [env.base_api_scope]);

  return {
    interactionType: InteractionType.Redirect,
    protectedResourceMap,
  };
}

export function MSALGuardConfigFactory(): MsalGuardConfiguration {
  return {
    interactionType: InteractionType.Redirect,
    loginFailedRoute: '/login-failed',
  };
}

@NgModule({
  declarations: [
    AppComponent,
    EntitlementServiceComponent,
    EntitlementServiceClientComponent,
    EntitlementClientComponent,
    ServiceComponent,
    HomeComponent,
    ClientComponent,
    FilterClientPipe,
    FilterEntitlementClientNamePipe,
    FilterServiceNamePipe,
    FilterEntitlementValuePipe,
    ClientInputComponent,
    ServiceCardComponent,
    ApiDocumentComponent,
    SearchKeyInputComponent,
  ],
  imports: [
    AppRoutingModule,
    BrowserModule,
    MsalModule,
    HttpClientModule,
    SharedModule,
    FormsModule,
    ReactiveFormsModule,
    AutocompleteLibModule,
    UnityModule,
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: MsalInterceptor,
      multi: true,
    },
    {
      provide: MSAL_INSTANCE,
      useFactory: MSALInstanceFactory,
    },
    {
      provide: MSAL_GUARD_CONFIG,
      useFactory: MSALGuardConfigFactory,
    },
    {
      provide: MSAL_INTERCEPTOR_CONFIG,
      useFactory: MSALInterceptorConfigFactory,
    },
    MsalService,
    MsalGuard,
    MsalBroadcastService,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
